import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_466aadf3 from 'nuxt_plugin_plugin_466aadf3' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_swplugin_4539c6a2 from 'nuxt_plugin_swplugin_4539c6a2' // Source: ./sw.plugin.js (mode: 'client')
import nuxt_plugin_plugin_77cd92db from 'nuxt_plugin_plugin_77cd92db' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_main_a750668e from 'nuxt_plugin_main_a750668e' // Source: ./firebase-module/main.js (mode: 'all')
import nuxt_plugin_initAuth_714995ba from 'nuxt_plugin_initAuth_714995ba' // Source: ./firebase-module/initAuth.js (mode: 'client')
import nuxt_plugin_axios_7f43ed89 from 'nuxt_plugin_axios_7f43ed89' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_templatesplugin6f6ccb06_51a41317 from 'nuxt_plugin_templatesplugin6f6ccb06_51a41317' // Source: ./templates.plugin.6f6ccb06.js (mode: 'client')
import nuxt_plugin_templatesplugin65ea5354_27169581 from 'nuxt_plugin_templatesplugin65ea5354_27169581' // Source: ./templates.plugin.65ea5354.js (mode: 'client')
import nuxt_plugin_lazyload_10f2b7b2 from 'nuxt_plugin_lazyload_10f2b7b2' // Source: ../../src/plugins/lazyload.js (mode: 'client')
import nuxt_plugin_snotify_8e8efa1e from 'nuxt_plugin_snotify_8e8efa1e' // Source: ../../src/plugins/snotify.js (mode: 'client')
import nuxt_plugin_nuxtquillplugin_745506c8 from 'nuxt_plugin_nuxtquillplugin_745506c8' // Source: ../../src/plugins/nuxt-quill-plugin.js (mode: 'client')
import nuxt_plugin_nuxtvideoplayerplugin_7826a9de from 'nuxt_plugin_nuxtvideoplayerplugin_7826a9de' // Source: ../../src/plugins/nuxt-video-player-plugin.js (mode: 'client')
import nuxt_plugin_vuexpersist_25bdab30 from 'nuxt_plugin_vuexpersist_25bdab30' // Source: ../../src/plugins/vuex-persist.js (mode: 'client')
import nuxt_plugin_quillemoji_f13f5aa2 from 'nuxt_plugin_quillemoji_f13f5aa2' // Source: ../../src/plugins/quill-emoji.js (mode: 'client')
import nuxt_plugin_vueobservevisibility_66676af7 from 'nuxt_plugin_vueobservevisibility_66676af7' // Source: ../../src/plugins/vue-observe-visibility.js (mode: 'client')
import nuxt_plugin_vuetimer_1fe14922 from 'nuxt_plugin_vuetimer_1fe14922' // Source: ../../src/plugins/vue-timer.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"FitnHealthy","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, height=device-height, initial-scale=1, maximum-scale=5","mobileAppIOS":true},{"hid":"description","name":"description","content":"Personalized ftness programs that will get you Fit, while building a Healthy lifestyle you always wanted."},{"name":"facebook-domain-verification","content":"411m2yvn919den391yyruxq1a3ren9"},{"name":"msapplication-TileColor","content":"#9ae17b"},{"name":"theme-color","content":"#3B8070"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"fitnhealthy"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"fitnhealthy"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"fitnhealthy"}],"link":[{"rel":"preload","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Oswald:wght@400;500;600&display=swap","as":"style"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Oswald:wght@400;500;600&display=swap"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_466aadf3 === 'function') {
    await nuxt_plugin_plugin_466aadf3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swplugin_4539c6a2 === 'function') {
    await nuxt_plugin_swplugin_4539c6a2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_77cd92db === 'function') {
    await nuxt_plugin_plugin_77cd92db(app.context, inject)
  }

  if (typeof nuxt_plugin_main_a750668e === 'function') {
    await nuxt_plugin_main_a750668e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initAuth_714995ba === 'function') {
    await nuxt_plugin_initAuth_714995ba(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7f43ed89 === 'function') {
    await nuxt_plugin_axios_7f43ed89(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin6f6ccb06_51a41317 === 'function') {
    await nuxt_plugin_templatesplugin6f6ccb06_51a41317(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin65ea5354_27169581 === 'function') {
    await nuxt_plugin_templatesplugin65ea5354_27169581(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyload_10f2b7b2 === 'function') {
    await nuxt_plugin_lazyload_10f2b7b2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_snotify_8e8efa1e === 'function') {
    await nuxt_plugin_snotify_8e8efa1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtquillplugin_745506c8 === 'function') {
    await nuxt_plugin_nuxtquillplugin_745506c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvideoplayerplugin_7826a9de === 'function') {
    await nuxt_plugin_nuxtvideoplayerplugin_7826a9de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_25bdab30 === 'function') {
    await nuxt_plugin_vuexpersist_25bdab30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_quillemoji_f13f5aa2 === 'function') {
    await nuxt_plugin_quillemoji_f13f5aa2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_66676af7 === 'function') {
    await nuxt_plugin_vueobservevisibility_66676af7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetimer_1fe14922 === 'function') {
    await nuxt_plugin_vuetimer_1fe14922(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
